import axios from "axios";

let checkIntervalId = null;

const requestForCheckIsLogged = async () => {
    await axios
        .get("/api/checkAuth")
        .then((res) => {
            if (res.status !== 200) {
                window.location.href = "/login";
            }
        })
        .catch((err) => {
            window.location.href = "/login";
        });
};

const startInterval = () => {
    checkIntervalId = setInterval(requestForCheckIsLogged, 300000);
};

const stopInterval = () => {
    clearInterval(checkIntervalId);
};

if (!document.querySelector("body").classList.contains("no-check-auth")) {
    startInterval();
}

window.addEventListener("beforeunload", () => {
    stopInterval();
});
